'use strict'

const setImmediate = require('async/setImmediate')

module.exports = function toCallback (doWork) {
  return function (input, callback) {
    const done = (err, res) => setImmediate(() => {
      callback(err, res)
    })

    let res
    try {
      res = doWork(input)
    } catch (err) {
      done(err)
      return
    }

    done(null, res)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/ipld-eth-block-list/~/multihashing-async/src/to-callback.js
// module id = 553
// module chunks = 0